import React, { Component } from "react";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import t from "tcomb-form";
import myCustomTemplate from "../Common/customTemplate";
import "./ForgotPassword.css";

const Form = t.form.Form;

var checkpassword = null;

const mobileField = t.refinement(t.Number, value => {
  return JSON.stringify(value).length === 10;
});
const otpField = t.refinement(t.Number, value => {
  return JSON.stringify(value).length === 6;
});
const newPasswordField = t.refinement(t.String, value => {
  checkpassword = value;
  return value.length > 5;
});
const retypePasswordField = t.refinement(t.String, value => {
  return value === checkpassword;
});
const Person = t.struct({
  mobileNo: mobileField
});
const otpFieldStruct = t.struct({
  otpNo: otpField
});
const resetFieldStruct = t.struct({
  newPassword: newPasswordField,
  retypePassword: retypePasswordField
});
const options = {
  fields: {
    mobileNo: {
      template: myCustomTemplate,
      config: {
        placeholder: "Mobile number",
        errorMessage: "Invalid mobile number",
        className: "error_msg",
        labelHide: true,
        type: "text"
        // label: "Mobile Number",
      }
    }
  }
};

const otpoptions = {
  fields: {
    otpNo: {
      template: myCustomTemplate,
      config: {
        placeholder: "One time password",
        errorMessage: "Invalid OTP",
        labelHide: true

        // label: "Enter Your OTP",
      }
    }
  }
};
const resetoptions = {
  fields: {
    newPassword: {
      template: myCustomTemplate,
      config: {
        placeholder: "New password",
        errorMessage: "Invalid password",
        labelHide: true,
        // label: "New Password",
        type: "password",
        id: "my_id"
      }
    },

    retypePassword: {
      template: myCustomTemplate,
      config: {
        placeholder: "Re-type password",
        errorMessage: "Invalid password",
        labelHide: true,
        // label: "Re-type Password",
        type: "password",
        id: "my_id_1"
      }
    }
  }
};
class Forgotpassword extends Component {
  constructor() {
    super();
    this.state = {
      shown: true,
      shownph: true,
      value: {
        mobileNo: "",
        otpNo: ""
      }
    };
  }
  onChangeMobno(Person2, path) {
    this.refs.form.getValue();
    // console.log("onchange-----", Person2, path);
  }
  otpFormChange(otpChng, path) {
    this.refs.form.getValue();
  }
  resetFormChange(resetChng, path) {
    this.refs.form.getValue();
  }

  submitMobno = () => {
    var mobValue = this.refs.form.getValue();

    if (mobValue) {
      this.props.forgotpassword(mobValue);
    }
    // this.props.logins(mobValue);
    window.scrollTo(0, 0);
  };

  otpsubmit = () => {
    var otpNo = this.refs.form.getValue();
    if (otpNo) {
      this.props.CheckOtp(otpNo);
    }
    window.scrollTo(0, 0);
  };

  resetSubmit = () => {
    var resetValue = this.refs.form.getValue();
    if (resetValue) {
      this.props.pswdChange(resetValue);
    }
    window.scrollTo(0, 0);
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.setInitialScreen();
  }
  render() {
    return (
      <div>
        <Container>
          <Row>
            {this.props.screen === "ForgotNo" && (
              <Col xs={12} md={12} sm={12} className="main_columForgot">
                <Card className="cardMainforgot">
                  <Card.Title className="cardhead">
                    <div className="loginpagemain">
                      <Row>
                        {/* <Image
                              className="loginfrstImg"
                              src={require("../../../src/assets/img/RNTLicon.png")}
                            />{" "} */}
                        <h3 className="loginHead">Med Lynx</h3>
                      </Row>
                    </div>
                  </Card.Title>
                  <div>
                    <h3 className="loginHd">Forgot Password</h3>
                  </div>
                  <Card.Body className="forgotpasswordform">
                    <p className="forgotpara">
                      Enter your mobile number and we'll send an OTP to reset
                      your password
                    </p>

                    <div className=" hidingcntnt">
                      <div className="forgotFormGrid">
                        <Form
                          ref="form"
                          className="fogot_form"
                          type={Person}
                          options={options}
                          value={this.state.value}
                          onChange={(v, path) => this.onChangeMobno(v, path)}
                        />
                      </div>
                      <div className="btnforgot_div">
                        <Button
                          type="submit"
                          className="forgot_button"
                          onClick={this.submitMobno}
                        >
                          Next
                        </Button>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            )}

            {this.props.screen === "ForgotOtp" && (
              <Col xs={12} md={12} sm={12} className="main_columLgnOtp">
                <Card className="cardMainLgnOtp">
                  <div></div>
                  <Card.Body className="forgotpasswordotp">
                    <Card.Title className="cardhead">
                      <h3 className="otphead">Enter your OTP</h3>
                    </Card.Title>
                    <p className="otppara">
                      We have sent you the access code via SMS for mobile number
                      verification
                    </p>

                    {/* <div className="otphidingcntnt"> */}
                    <div className="otpFormGridLgn">
                      <Form
                        ref="form"
                        type={otpFieldStruct}
                        options={otpoptions}
                        value={this.state.value}
                        onChange={(v, path) => this.otpFormChange(v, path)}
                      />
                    </div>
                    <div className="btnotp_div">
                      <Button
                        type="submit"
                        className="otp_Button"
                        onClick={this.otpsubmit}
                      >
                        Submit
                      </Button>
                    </div>
                    <h6 className="dntgetotpSection">
                      Didn't receive OTP?
                      <br />
                    </h6>
                    <div
                      className="resendcodeSection"
                      onClick={() => this.props.resendOtp()}
                    >
                      Resend OTP
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            )}

            {this.props.screen === "ForgotPswrdChng" && (
              <Col xs={12} md={12} sm={12} className="main_columLgnReset">
                <Card className="cardMainreset">
                  <Card.Body>
                    <div></div>
                    <Card.Title className="cardhead">
                      <h3 className="resethead">Reset Password</h3>
                    </Card.Title>
                    <p className="resetpara">Enter your new password</p>

                    <div className="resethidingcntnt">
                      <div className="resetFormGrid">
                        <Form
                          ref="form"
                          type={resetFieldStruct}
                          options={resetoptions}
                          value={this.state.value}
                          onChange={(v, path) => this.resetFormChange(v, path)}
                        />
                      </div>
                      <div className="btnreset_div">
                        <Button
                          type="submit"
                          className="resetbutton"
                          onClick={this.resetSubmit}
                        >
                          Next
                        </Button>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    );
  }
}

export default Forgotpassword;
